import { render, staticRenderFns } from "./IRadio.vue?vue&type=template&id=73a24e9f&"
import script from "./IRadio.vue?vue&type=script&lang=ts&"
export * from "./IRadio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports